/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB4PSIxLjUiIHk9IjEuNSIgd2lkdGg9IjkiIGhlaWdodD0iOSIgcng9IjQuNSIgZmlsbD0iI0M3Q0VENCIgc3Ryb2tlPSIjRTVFOUVCIiBzdHJva2Utd2lkdGg9IjMiLz48L3N2Zz4=";